import { render, staticRenderFns } from "./AddressFetchList.vue?vue&type=template&id=2afc4394&scoped=true"
import script from "./AddressFetchList.vue?vue&type=script&lang=js"
export * from "./AddressFetchList.vue?vue&type=script&lang=js"
import style0 from "./AddressFetchList.vue?vue&type=style&index=0&id=2afc4394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afc4394",
  null
  
)

export default component.exports